var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnDiy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "qoj7lb3coa",
    d: "M0 0.076L9.575 0.076 9.575 7.571 0 7.571z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l9opa6qlxc",
    d: "M0.028 0.076L6.114 0.076 6.114 6.679 0.028 6.679z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6xohh0bete",
    d: "M0.094 0.009L5.458 0.009 5.458 5.729 0.094 5.729z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-126 -102) translate(126 102) translate(0 .028)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dze8ea8wnb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qoj7lb3coa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2C2C2C",
    d: "M5.397 6.402c-.266-.253-.521-.503-.785-.743-.08-.073-.179-.131-.279-.173-.183-.076-.337-.025-.467.125-.158.183-.233.408-.293.63-.091.344-.27.623-.523.868-.154.148-.29.313-.428.462L0 4.716c.04-.042.081-.084.12-.128.22-.24.438-.478.654-.72.056-.062.114-.082.196-.056.134.043.269.081.405.117.233.062.437.011.58-.188.137-.192.272-.388.382-.596.386-.729.843-1.41 1.414-2.006C4.311.554 4.991.177 5.81.091c.374-.04.746.007 1.118.08.816.16 1.583.469 2.368.724.09.029.178.06.266.092.004.001.006.01.014.024-.12.03-.238.063-.357.091-.708.164-1.375.424-1.983.823-.259.17-.478.382-.622.654-.22.419-.125.817.134 1.183.151.213.33.407.505.62l-1.855 2.02",
    mask: "url(#dze8ea8wnb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2C2C2C",
    d: "M5.855 7.013l1.873-2.039 1.568 1.712 3.998 4.36c.178.194.355.39.535.583.722.775.482 1.977-.485 2.415-.297.134-.593.157-.912.035-.322-.124-.552-.341-.772-.587-1.12-1.253-2.244-2.503-3.366-3.754l-2.349-2.62c-.029-.031-.056-.065-.09-.105",
    transform: "translate(-126 -102) translate(126 102)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-126 -102) translate(126 102) translate(8.811 .653)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6912wgi66d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l9opa6qlxc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2C2C2C",
    d: "M1.469 5.676l-.474-.52 2.969-3.23-.317-.347L.67 4.8l-.64-.698c.23-.247.459-.489.685-.732L3.332.562C3.543.336 3.786.16 4.1.098c.345-.067.66.031.957.188.61.322.957.843 1.043 1.511.068.522-.113.99-.473 1.383-.662.722-1.326 1.441-1.987 2.163-.4.436-.797.874-1.195 1.31-.007.008-.015.013-.03.026L1.8 6.01l3.01-3.268-.322-.35C3.48 3.49 2.475 4.583 1.468 5.677",
    mask: "url(#6912wgi66d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-126 -102) translate(126 102) translate(1.678 9.194)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hzxad7sjwf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6xohh0bete"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2C2C2C",
    d: "M5.458.775l-.83.887-.931.994c-.348.37-.606.802-.87 1.231-.2.327-.404.651-.61.974-.036.054-.086.104-.141.138-.373.236-.749.467-1.123.702-.064.04-.112.04-.166-.017-.214-.23-.43-.458-.647-.685-.055-.057-.058-.113-.021-.18.223-.406.439-.815.672-1.215.059-.102.164-.183.262-.254.454-.33.913-.654 1.37-.98.337-.238.602-.548.881-.844.458-.487.913-.976 1.37-1.463.028-.031.055-.088.11-.028l.674.74",
    mask: "url(#hzxad7sjwf)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDiy);
export default __webpack_public_path__ + "static/media/icn_diy.4da62e009539c3b80663dbec65cb5b22.svg";
export { ForwardRef as ReactComponent };